import { Link } from 'react-router-dom';

export default function PartnershipHero() {
  return (
    <section className="relative pt-20 min-h-[440px] md:min-h-[500px] flex items-end overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20aerial%20view%20of%20lush%20dense%20deep%20green%20tropical%20forest%20canopy%20with%20dramatic%20mist%20and%20moody%20low%20light%2C%20rich%20dark%20emerald%20tones%20with%20deep%20shadows%2C%20cinematic%20nature%20landscape%20perfect%20for%20text%20overlay%20contrast&width=1920&height=500&seq=partner-hero-bg-03&orientation=landscape"
          alt="合作相關背景"
          className="w-full h-full object-cover object-center"
        />
        {/* 左右漸層遮罩 */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0d2210]/92 via-[#0d2210]/72 to-[#0d2210]/40" />
        {/* 上下輔助遮罩，強化文字區底部對比 */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0d2210]/75 via-transparent to-[#0d2210]/30" />
      </div>

      <div className="relative z-10 w-full max-w-screen-xl mx-auto px-6 lg:px-10 pb-16 pt-28">
        <div className="max-w-2xl">
          <span className="inline-block bg-[#4CAF50]/25 border border-[#4CAF50]/50 text-green-300 text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-5 tracking-wide">
            合作相關
          </span>
          <h1 className="text-white font-bold text-[2.25rem] md:text-[3rem] leading-tight mb-5">
            <span className="block">開啟合作，共創</span>
            <span className="block text-green-300">品牌成長新契機</span>
          </h1>
          <p className="text-gray-200 text-[1.0625rem] leading-[1.75] max-w-xl mb-8">
            無論您是新創品牌、電商通路或傳統零售商，康永生技都能提供最適合的 ODM／OEM 代工合作方案，讓您的產品快速上市。
          </p>
          <div className="flex flex-wrap gap-4">
            <Link
              to="/contact"
              className="whitespace-nowrap bg-[#4CAF50] hover:bg-[#43a047] text-white font-semibold text-[1rem] px-7 py-3.5 rounded-full transition-all duration-300 cursor-pointer"
            >
              立即洽詢合作
            </Link>
            <Link
              to="/services"
              className="whitespace-nowrap bg-white/15 hover:bg-white/25 border border-white/60 text-white font-semibold text-[1rem] px-7 py-3.5 rounded-full transition-all duration-300 cursor-pointer"
            >
              查看服務項目
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
